import React from 'react';
import { Spacer } from '@tfecom-thermofisher/react-komodo-design';

import { Divider } from 'src/core/components';

const SectionDividerComponent = () => (
  <>
    <Spacer bottom={16} />
    <Divider bottom />
    <Spacer bottom={16} />
  </>
);

SectionDividerComponent.propTypes = {};

export default SectionDividerComponent;
